import type { ContactFilters } from '@/lib/contacts/types'

export function contactsPath(filters: ContactFilters) {
  const params = contactFilterParams(filters)
  const query = params.toString()
  return query.length > 0 ? `/api/v1/contacts?${query}` : '/api/v1/contacts'
}

export function contactsExportPath(filters: ContactFilters, contactIds?: number[]) {
  const params = contactFilterParams(filters)
  for (const id of [...(contactIds ?? [])].sort((left, right) => left - right)) {
    params.append('contact_ids[]', id.toString())
  }

  const query = params.toString()
  return query.length > 0 ? `/api/v1/contacts/export?${query}` : '/api/v1/contacts/export'
}

export function matchingFromFilters(filters: ContactFilters) {
  const matching: Record<string, string | boolean> = {}
  const search = filters.search.trim()

  if (search.length > 0) matching.search = search
  if (filters.contactType !== 'all') matching.contact_type = filters.contactType
  if (filters.marketingOptOut !== 'all') matching.marketing_opt_out = filters.marketingOptOut
  if (filters.includeArchived) matching.include_archived = true

  return matching
}

export function hasContactFilters(filters: ContactFilters) {
  return Object.keys(matchingFromFilters(filters)).length > 0
}

function contactFilterParams(filters: ContactFilters) {
  const params = new URLSearchParams()
  const search = filters.search.trim()
  if (search.length > 0) params.set('search', search)
  if (filters.contactType !== 'all') params.set('contact_type', filters.contactType)
  if (filters.marketingOptOut !== 'all') params.set('marketing_opt_out', filters.marketingOptOut)
  if (filters.includeArchived) params.set('include_archived', 'true')

  return params
}
